export default "__VITE_ASSET__VU4k1c0g__"